module.exports = __webpack_public_path__ + "static/media/rls_logo.812f79ed.png";